import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

import TextField from 'WeployDesignLanguage/inputs/TextField';

import dagstorp from 'LegacyWeployDesignLanguage/dagstorp';
import { ClearIcon, SearchIcon } from 'LegacyWeployDesignLanguage/icons';

const ENTER_KEY_CODE = 13;

const StyledSearchIcon = styled(SearchIcon)`
  color: ${props => props.theme.colors.environment.icon};
`;

const StyledClearIcon = styled(ClearIcon)`
  color: ${props => props.theme.colors.environment.icon};
`;

const StyledInputAdornment = withStyles({
  positionStart: {
    marginLeft: dagstorp.spacing[1],
    marginRight: dagstorp.spacing[0],
  },
})(InputAdornment);

const searchIconAdornment = {
  startAdornment: (
    <StyledInputAdornment position="start">
      <StyledSearchIcon />
    </StyledInputAdornment>
  ),
};

const SearchField = (props) => {
  const {
    value,
    onClear,
    onSubmit,
    ...rest
  } = props;

  const handleKeyPress = ({ charCode }) => {
    if (charCode === ENTER_KEY_CODE) {
      onSubmit(value);
    }
  };

  return (
    <TextField
      InputProps={(value
        ? {
           ...searchIconAdornment,
           endAdornment: (
             <InputAdornment position="end">
               <IconButton size="small" onClick={onClear}>
                 <StyledClearIcon />
               </IconButton>
             </InputAdornment>
            ),
          }
        : searchIconAdornment
      )}
      value={value}
      onKeyPress={handleKeyPress}
      {...rest}
    />
  );
};

SearchField.propTypes = {
  value: PropTypes.string,
  onClear: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

SearchField.defaultProps = {
  value: '',
};


export default SearchField;
